import { type AggResponse, fetchAgg } from '../../../common/utils/fetch-agg';

export type QuickFindDetailIds = {
	issueIds: string[];
	boardIds: string[];
	pullRequestIds: string[];
};

export type QuickFindDetails = {
	jira_issuesByIds?: Array<{
		id: string;
		issueType?: { avatar?: { medium?: string | null } | null } | null;
	} | null> | null;
	jira_boardsByIds?: Array<{ id: string; iconUrl: string | null } | null> | null;
	external_entities?: {
		pullRequest?: Array<{ id: string; pullRequestStatus?: string | null } | null> | null;
	} | null;
};

const QUICK_FIND_JIRA_DETAILS_QUERY = `
	query QuickFindJiraDetails(
		$issueIds: [ID!]!, $boardIds: [ID!]!, $pullRequestIds: [ID!]!,
		$includeIssues: Boolean!, $includeBoards: Boolean!, $includePullRequests: Boolean!
	) {
		jira_issuesByIds(ids: $issueIds) @include(if: $includeIssues) {
			id
			issueType { avatar { medium } }
		}
		jira_boardsByIds(ids: $boardIds) @include(if: $includeBoards) {
			id iconUrl
		}
		external_entities(ids: $pullRequestIds) @include(if: $includePullRequests)
			@optIn(to: "ExternalDataDepotQueryV2") {
			pullRequest { id pullRequestStatus: status }
		}
	}
`;

/** Fetch display details over HTTP; callers own when to request and apply them. */
export const fetchJiraQuickFindDetails = (
	ids: QuickFindDetailIds,
	{ aggAbsoluteUrl, edgeRegionHint }: { aggAbsoluteUrl?: string; edgeRegionHint?: string },
): Promise<AggResponse<QuickFindDetails>> => {
	const variables = {
		...ids,
		includeIssues: ids.issueIds.length > 0,
		includeBoards: ids.boardIds.length > 0,
		includePullRequests: ids.pullRequestIds.length > 0,
	};
	return fetchAgg<typeof variables, QuickFindDetails>({
		graphQuery: QUICK_FIND_JIRA_DETAILS_QUERY,
		operationName: 'QuickFindJiraDetails',
		variables,
		aggAbsoluteUrl,
		headers: edgeRegionHint ? { 'atl-edge-region-hint': edgeRegionHint } : undefined,
	});
};
